module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"mantra":"Oh wow, you\u0027re such| an explorer!","desc":"Your discovery just encouraged us to pick up the pace! <br> We will get this done in no time.","back":"Back to home"},"ar":{"mantra":"رائع! يبدو أنك مستكشفٌ ماهر!","desc":"لقد شجعنا اكتشافك على تسريع الوتيرة! <br> ستري هذا خلال وقت قصير.","back":"العودة للرئيسية"}}')
  delete Component.options._Ctor
}
